<template>
    <div class="getTicketDetails" v-if="show && eventinfo.title">
        <div class="ticketMsg">
            <p class="title">{{eventinfo.title}}</p>
            <div class="time">{{eventinfo.begintime}} - {{eventinfo.endtime}}</div>
            <p class="address">{{eventinfo.address}}</p>
            <div class="dotted">
                <div class="line"></div>
                <div class="left"></div>
                <div class="right"></div>
            </div>
            <div class="ticketItem">
                <div class="nameBox">
                    <div class="ticketName">{{ticketinfo.ticketname}}</div>
                    <div class="price">
                        <p class="ticketType" v-if="ticketinfo.seasonticketcount !== 1">{{ticketinfo.seasonticketcount}}人套票</p>
                        <p class="priceText">￥{{ticketinfo.uprice}} x {{ticketinfo.seasonticketcount}}</p>
                    </div>
                </div>
                <div class="participant">
                    <div class="left">参加人</div>
                    <div class="right">
                        <div class="textItem" v-for="(obj, i) in ticketinfo.joinlist" :key="i">
                            <p class="name">{{obj.joinername}}</p>
                            <p class="phoneNum">{{obj.joinermobile}}</p>
                        </div>
                    </div>
                </div>
                <div class="ticketNum">
                    <div class="left">票号</div>
                    <div class="right">
                        <div class="item" v-for="(obj, i) in ticketinfo.ticketnolist" :key="i">
                            <p>{{obj.ticketno}}</p>
                        </div>
                    </div>
                </div>
                <div class="statusBox">
                    <p>状态</p>
                    <p class="statusText">{{ticketinfo.ticketstatusname}}</p>
                </div>
            </div>
        </div>
        <div class="checkAtyBtn">
            <van-button type="default" @click="shareTips">分享票券给好友</van-button>
            <van-button type="default" @click="checkAtyMsg">查看活动详情</van-button>
        </div>
        <sharePopup ref="sharePopup"></sharePopup>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import {getEventOrderTicket, saveEventShareTicket} from 'api/activeTools'
import {getWXSDKSetting} from 'common/js/wxSDKSetting'
import sharePopup from '../components/sharePopup'
export default {
    name: 'getTicketDetails',
    data() {
        return {
            eventinfo: {
                title: '',
                coveratturlid: '',
                begintime: '',
                endtime: '',
                address: ''
            },
            ticketinfo: {},
            eventid: this.$route.query.eventid,
            itemid: this.$route.query.itemid,
            shareid: '',
            show: false
        }
    },
    mounted() {
        this.getEventOrderTicket()
    },
    methods: {
        // 分享设置
        _editKmcShare(obj) {
            let href = this.$router.resolve({name: 'getTicket'}).href
            let link = window.location.protocol + '//' + window.location.host + href + '?eventid=' + this.eventid + '&shareid=' + this.shareid
            // alert(link)
            console.log(link)
            // console.log(this.shareid)
            // alert(link)
            getWXSDKSetting(
                {
                    title: obj.title,
                    desc: obj.subtitle,
                    link: link,
                    imgUrl: obj.coveratturlid
                }
            )
        },
        // 分享票券给好友 
        saveEventShareTicket() {
            let itemid = this.ticketinfo.itemid
            this.setLoading(true)
            saveEventShareTicket({
                data: {eventid: this.eventid, orderno: this.eventinfo.orderno, itemid},
                success: data => {
                    this.setLoading(false)
                    this.shareid = data.data.shareid
                    this._editKmcShare(this.eventinfo)
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        shareTips() {
            // if (this.shareid) {
            this.$refs.sharePopup.open()
            // } else {
                // this.saveEventShareTicket()
            // }
        },
        getEventOrderTicket() {
            this.setLoading(true)
            getEventOrderTicket({
                data: {eventid: this.eventid, itemid: this.itemid},
                success: data => {
                    this.setLoading(false)
                    this.eventinfo = data.data.eventinfo
                    document.title = this.eventinfo.title
                    this.ticketinfo = data.data.ticketlist
                    this.show = true
                    this.saveEventShareTicket()
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        checkAtyMsg() {
            this.$router.push({name: 'ActivityDetail', query: {eventid: this.eventid}})
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        sharePopup
    }
}
</script>
<style lang="scss">
    .getTicketDetails{
        padding-top: 1rem;
        position: relative;
        height: 100%;
        box-sizing: border-box;
        .ticketMsg{
            margin: 0rem 0.6rem 0;
            padding: 0.4rem 0.28rem 0.6rem;
            background: #fff;
            border-radius: 0.1rem;
            box-shadow:0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
            .title{
                width: 100%;
                font-size: 0.28rem;
                line-height: 0.40rem;
                font-weight: 550;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .time{
                font-size: 0.24rem;
                color: #666666;
                margin-top: 0.2rem;
            }
            .address{
                font-size: 0.24rem;
                color: #666666;
                margin-top: 0.12rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .dotted{
                padding: 0.3rem 0;
                position: relative;
                .line{
                    border-bottom: 0.01rem dashed #999999;
                }
                .left, .right{
                    width: 0.15rem;
                    height: 0.3rem;
                    background: #F5F7FA;
                    position: absolute;
                    top: 0.15rem;
                }
                .left{
                    left: -0.3rem;
                    border-radius: 0 0.15rem 0.15rem 0;
                }
                .right{
                    right: -0.3rem;
                    border-radius: 0.15rem 0 0 0.15rem;
                }
            }
            .nameBox{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-top: 0.2rem;
                padding-bottom: 0.4rem;
                .ticketName{
                    font-size: 0.28rem;
                    line-height: 0.4rem;
                    font-weight: 500;
                }
                .price{
                    display: flex;
                    align-items: center;
                    .ticketType{
                        color: #999999;
                        font-size: 0.2rem;
                        margin-right: 0.32rem;
                    }
                    .priceText{
                        font-size: 0.28rem;
                        color: #333333;
                    }
                }
            }
            .participant, .ticketNum{
                display: flex;
                justify-content: space-between;
                color: #666666;
                padding-bottom: 0.4rem;
                font-size: 0.28rem;
                .left{
                    line-height: 0.4rem;
                }
                .right{
                    .textItem, .item{
                        display: flex;
                        justify-content: space-between;
                        p{
                            line-height: 0.4rem;
                        }
                        .name{
                            margin-right: 0.5rem;
                        }
                    }
                }
            }
            .statusBox{
                display: flex;
                justify-content: space-between;
                color: #666666;
                font-size: 0.28rem;
                .statusText{
                    color: #0ABF53;
                }
            }
        }
        .checkAtyBtn{
            position: fixed;
            bottom: 0;
            // padding-top: 0.6rem;
            height: 1.1rem;
            line-height: 1.1rem;
            background: #fff;
            display: flex;
            width: 100%;
            .van-button{
                flex: 1;
                height: 0.76rem;
                line-height: 0.76rem;
                border-radius: 0.4rem;
                color: #666666;
                font-size: 0.28rem;
                margin: 0.17rem 0.16rem;
            }
        }
    }
</style>